const $ = jQuery.noConflict();

'use strict';
const MyAccount = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domBody: $('body'),
	$domLoginEyeIcon: $('.js-woocommerce-form__input-icon, .js-my-account-input-fields__popup-input-eye'),
	$domLoginBtn: $('.my-account__login-btn, .my-account__lost-pass-btn, .my-account__reset-pass-btn'),
	$domLoginLoader: $('.js-woocommerce-form__input-loader'),
	$domMyAccHeaderLink: $('.js-myaccount-header__link'),
	$domMyAccHeaderLinkDrop: $('.js-myaccount-header__link-drop-wrap'),
	$domBookingCancelBtn: $('.js-myaccount__btn-cancel'),
	$domBookingCancelPopup: $('.js-booking-cancel__popup'),
	$domBookingCancelIconAndBtn: $('.js-booking-cancel__popup-icon, .js-booking-cancel__popup-btn'),
	$domMyAccNavHamburger: $('.js-my-account__nav-holder-hamb'),
	$domMyAccNavHolder: $('.js-my-account__nav-holder'),
	$domMyAccEditPopupLink: $('.js-myaccount-input__fields-box-link'),
	$domMyAccEditPopup: $('.js-my-account-input-fields__popup'),
	$domMyAccEditPopupNew: $('.js-my-account-input-fields__popup--new'),
	$domMyaccEditPopupsWrap: $('.js-my-account-input-fields__popup, .js-my-account-input-fields__popup--new'),
	$domMyAccEditBtnOpen: $('.js-myaccount-input__fields-btn'),
	$domEditPopupCancelIconAndBtn: $('.js-my-account-input-fields__popup-btn, .js-my-account-input-fields__popup-icon'),
	$domMyAccountTableWrap: $('.myaccount-table__body-wrap'),
	$domMyAccountTableBtnsHolder: $('.myaccount-table__body-wrap-btns-holder'),
	classActive: 'is-active',
	classPreventScroll: 'prevent-scroll',

	/** @description Initialize */
	init: function() {
		this.showPassword();
		this.loginLoader();
		this.myAccountHeaderLinkDropdown();
		this.bookingCancelPopupShow();
		this.bookingModifyPopupShow();
		this.bookingCancelPopupHide();
		this.bookingModifyPopupHide();
		this.declineModify();
		this.closeBookingCancelPopup();
		this.closeMenuOnOutsideContainerClick();
		if (window.innerWidth < 1200) {
			this.myAccountNav();
			this.closeAccountNavOnOutsideContainerClick();
		}
		this.myAccountPopupShow();
		this.myAccountPopupHide();
		this.myAccountCancelPopup();
		this.myAccountCloseMenuOnOutsideContainerClick();
		this.myAccountTableRowDropdown();
		$(document).ajaxStop(function() {
			MyAccount.bookingCancelPopupShow();
			MyAccount.bookingModifyPopupShow();
			MyAccount.myAccountHeaderLinkDropdown();
			MyAccount.bookingModifyPopupHide();
			MyAccount.declineModify();
			// const addPayment = $('body.woocommerce-add-payment-method');
			// if (addPayment.length > 0) {
			// 	const card = {
			// 		border: '2px solid #f7f9ff',
			// 		backgroundColor: '#f7f9ff',
			// 		padding: '10px 17px 11px',
			// 		paddingLeft: '30px',
			// 		maxWidth: '70%',
			// 		width: '70%',
			// 		margin: '5px',
			// 		height: '35px',
			// 		borderRadius: '30px',
			// 		'font-size': '18px',
			// 		fontFamily: 'Goldplay, Arial, Helvetica, sans-serif',
			// 	};
			// 	// eslint-disable-next-line no-undef
			// 	setIfieldStyle('card-number', card);
			// 	const cvvFrame = {
			// 		border: '2px solid #f7f9ff',
			// 		backgroundColor: '#f7f9ff',
			// 		padding: '10px 17px 11px',
			// 		paddingLeft: '30px',
			// 		borderRadius: '30px',
			// 		margin: '5px',
			// 		height: '35px',
			// 		width: '150px',
			// 		'font-size': '18px',
			// 		fontFamily: 'Goldplay, Arial, Helvetica, sans-serif',
			// 	};
			// 	// eslint-disable-next-line no-undef
			// 	setIfieldStyle('cvv', cvvFrame);
			// }
		});
	},

	/** @description slider example description e.g Banner slider */
	showPassword: function() {
		MyAccount.$domLoginEyeIcon.on('click', function() {
			const input = $(this).parent().find('input');
			if (input[0].type === 'password') {
				input[0].type = 'text';
				$(this).addClass('is-active');
			} else {
				input[0].type = 'password';
				$(this).removeClass('is-active');
			}
		});
	},

	loginLoader: function() {
		MyAccount.$domLoginBtn.on('click', function() {
			MyAccount.$domLoginLoader.show();
		});
	},

	myAccountHeaderLinkDropdown: function() {
		$('.js-myaccount-header__link').on('click', function() {
			$(this).toggleClass(MyAccount.classActive);
			$('.js-myaccount-header__link-drop-wrap').toggle('show');
		});
	},

	bookingCancelPopupShow: function() {
		$('.js-myaccount__btn-cancel').on('click', function() {
			const dataId = $(this).attr('data-id');
			$('.js-booking-cancel__popup').addClass(MyAccount.classActive);
			$('.js-cancel-order-sbv').attr('data-id', dataId);
		});
	},
	bookingModifyPopupShow: function() {
		$('.js-modify-popup-trigger').on('click', function() {
			const dataId = $(this).attr('data-id');
			$('.js-booking-modify__popup').addClass(MyAccount.classActive);
			$('.js-cancel-modify').attr('data-id', dataId);
		});
	},

	bookingCancelPopupHide: function() {
		MyAccount.$domBookingCancelIconAndBtn.on('click', function() {
			MyAccount.closeBookingCancelPopup();
		});
	},
	bookingModifyPopupHide: function() {
		$('.js-booking-cancel__popup-modify-icon').on('click', function() {
			$('.js-booking-modify__popup').removeClass('is-active');
		});
	},
	declineModify: function() {
		$('.js-booking-cancel__popup-modify-btn').on('click', function() {
			$('.js-booking-cancel__popup-modify-icon').trigger('click');
		});
	},

	closeBookingCancelPopup: function() {
		MyAccount.$domBookingCancelPopup.removeClass(MyAccount.classActive);
	},

	/* @description close menu if click outside container */
	closeMenuOnOutsideContainerClick: function() {
		MyAccount.$domBody.on('mouseup', function(e) {
			e.preventDefault();
			if (MyAccount.$domBookingCancelPopup.hasClass(MyAccount.classActive) && !MyAccount.$domBookingCancelPopup.is(e.target) && MyAccount.$domBookingCancelPopup.has(e.target).length === 0 && !MyAccount.$domBookingCancelIconAndBtn.is(e.target)) {
				MyAccount.closeBookingCancelPopup();
			}
		});
	},

	myAccountNav: function() {
		MyAccount.$domMyAccNavHamburger.on('click', function() {
			MyAccount.$domMyAccNavHolder.toggleClass(MyAccount.classActive);
			if (MyAccount.$domMyAccNavHolder.hasClass(MyAccount.classActive)) {
				MyAccount.$domBody.addClass(MyAccount.classPreventScroll);
			} else {
				MyAccount.$domBody.removeClass(MyAccount.classPreventScroll);
			}
		});
	},

	closeAccountNavOnOutsideContainerClick: function() {
		MyAccount.$domBody.on('mouseup', function(e) {
			e.preventDefault();
			if (MyAccount.$domMyAccNavHolder.hasClass(MyAccount.classActive) && !MyAccount.$domMyAccNavHolder.is(e.target) && MyAccount.$domMyAccNavHolder.has(e.target).length === 0) {
				MyAccount.$domMyAccNavHolder.removeClass(MyAccount.classActive);
			}
			MyAccount.$domBody.removeClass(MyAccount.classPreventScroll);
		});
	},

	myAccountPopupShow: function() {
		MyAccount.$domMyAccEditPopupLink.on('click', function() {
			MyAccount.$domMyAccEditPopup.addClass(MyAccount.classActive);
		});
		MyAccount.$domMyAccEditBtnOpen.on('click', function() {
			MyAccount.$domMyAccEditPopupNew.addClass(MyAccount.classActive);
		});
	},

	myAccountPopupHide: function() {
		MyAccount.$domEditPopupCancelIconAndBtn.on('click', function() {
			MyAccount.myAccountCancelPopup();
		});
	},

	myAccountCancelPopup: function() {
		MyAccount.$domMyaccEditPopupsWrap.removeClass(MyAccount.classActive);
	},

	/* @description close menu if click outside container */
	myAccountCloseMenuOnOutsideContainerClick: function() {
		MyAccount.$domBody.on('mouseup', function(e) {
			e.preventDefault();
			if (MyAccount.$domMyaccEditPopupsWrap.hasClass(MyAccount.classActive) && !MyAccount.$domMyaccEditPopupsWrap.is(e.target) && MyAccount.$domMyaccEditPopupsWrap.has(e.target).length === 0 && !MyAccount.$domEditPopupCancelIconAndBtn.is(e.target)) {
				MyAccount.myAccountCancelPopup();
			}
		});
	},

	myAccountTableRowDropdown: function() {
		MyAccount.$domMyAccountTableWrap.each(function(e, el) {
			$(el).on('click', function() {
				const _self = $(this);
				if (_self.hasClass(MyAccount.classActive)) {
					_self.removeClass(MyAccount.classActive);
					_self.find('.myaccount-table__body-wrap-btns-holder').slideUp();
				} else {
					_self.addClass(MyAccount.classActive);
					_self.find('.myaccount-table__body-wrap-btns-holder').slideDown();
					_self.siblings().removeClass(MyAccount.classActive).find('.myaccount-table__body-wrap-btns-holder').slideUp();
				}
			});
		});
	},
};

export default MyAccount;